import { ITransferPendingCoursesDatasource } from './../datasources/transfer_pending_courses_datasource';
import { TransferCreditsProgressState } from './../progression/transfer_credits_progress_state';
import { ITransferCoursesDatasource } from './../datasources/transfer_courses_datasource';
import { ITransferCollegesDatasource } from './../datasources/transfer_colleges_datasource';
import { ITransferMajorsDatasource } from './../datasources/transfer_majors_datasource';
import { ITransferExamsDatasource } from './../datasources/transfer_exams_datasource';
import { ITransferExamTypesDatasource } from './../datasources/transfer_exam_types_datasource';
import { ICommand, IQuery, IDefineCommand, IQueryMediator } from 'core-ts-types';

angular.module('capability-ng-transfer')
  .factory('clearTransferDatasourcesCommand', (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngTransferCreditsProgressState: TransferCreditsProgressState,
    ngTransferCoursesDatasource: ITransferCoursesDatasource,
    ngTransferPendingCoursesDatasource: ITransferPendingCoursesDatasource,
    ngTransferCollegesDatasource: ITransferCollegesDatasource,
    ngTransferExamTypesDatasource: ITransferExamTypesDatasource,
    ngTransferExamDatasource: ITransferExamsDatasource,
    ngTransferMajorsDatasource: ITransferMajorsDatasource): ICommand => {
    return defineCommand('clearTransferDatasourcesCommand', function clearTransferDatasourcesCommand(deferred: ng.IDeferred<IQuery[]>): void {

      ngTransferCreditsProgressState.clear();

      ngTransferCoursesDatasource.clear();
      ngTransferPendingCoursesDatasource.clear();
      ngTransferCollegesDatasource.clear();
      ngTransferMajorsDatasource.clear();
      ngTransferExamDatasource.clear();
      ngTransferExamTypesDatasource.clear();

      deferred.resolve(QueryMediator.runQueries(
        ngTransferCoursesDatasource,
        ngTransferPendingCoursesDatasource,
        ngTransferCollegesDatasource,
        ngTransferMajorsDatasource,
        ngTransferExamTypesDatasource,
        ngTransferExamDatasource
      ));

    });
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/clear_transfer_datasources_command.ts